import { heliosApi } from '.';
import { TAG_TYPES } from 'types/services';
import type {
  HeliosUserFilter,
  GetHeliosUserFiltersRes,
  GetHeliosUserFiltersReq,
  CreateHeliosUserFilterReq,
  UpdateHeliosUserFilterReq,
  DeleteHeliosUserFilterReq,
} from 'types/heliosUserFilters';

export const heliosUserFiltersService = heliosApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getHeliosUserFilters: builder.query<GetHeliosUserFiltersRes, GetHeliosUserFiltersReq>({
      query: (params) => ({
        url: 'UserFilters',
        method: 'GET',
        params: {
          TemplateId: params.templateId,
          UserId: params.userId,
          Type: params.type,
          AdministrationSectionType: params.administrationSectionType,
          Page: params.page,
          PageSize: params.pageSize,
        },
      }),
      providesTags: [TAG_TYPES.HELIOS_USER_FILTERS],
    }),

    getHeliosUserFilterById: builder.query<HeliosUserFilter, string>({
      query: (id) => ({
        url: `UserFilters/${id}`,
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.HELIOS_USER_FILTERS],
    }),

    createHeliosUserFilter: builder.mutation<HeliosUserFilter, CreateHeliosUserFilterReq>({
      query: (data) => ({
        url: 'UserFilters',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [TAG_TYPES.HELIOS_USER_FILTERS],
    }),

    updateHeliosUserFilter: builder.mutation<HeliosUserFilter, UpdateHeliosUserFilterReq>({
      query: (data) => ({
        url: 'UserFilters',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [TAG_TYPES.HELIOS_USER_FILTERS],
    }),

    deleteHeliosUserFilter: builder.mutation<void, DeleteHeliosUserFilterReq>({
      query: ({ ids }) => ({
        url: 'UserFilters',
        method: 'DELETE',
        params: { ids },
      }),
      invalidatesTags: [TAG_TYPES.HELIOS_USER_FILTERS],
    }),
  }),
});

export const {
  useGetHeliosUserFiltersQuery,
  useLazyGetHeliosUserFiltersQuery,
  useGetHeliosUserFilterByIdQuery,
  useCreateHeliosUserFilterMutation,
  useUpdateHeliosUserFilterMutation,
  useDeleteHeliosUserFilterMutation,
} = heliosUserFiltersService;
